import { render } from "./Inventory_WarehouseSections_Dialog.vue?vue&type=template&id=331b15cf&scoped=true&ts=true"
import script from "./Inventory_WarehouseSections_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_WarehouseSections_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_WarehouseSections_Dialog.vue?vue&type=style&index=0&id=331b15cf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331b15cf"]])

export default __exports__